import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthLayout } from './AuthLayout'
import { Field } from '../../components/ui/Field'
import { Input } from '../../components/ui/Input'
import { Button } from '../../components/ui/Button'
import { authApi } from '../../api/auth.api'
import { ApiError } from '../../api/client'
import { useAuth } from '../../auth/AuthContext'
import styles from './AuthLayout.module.css'

export function SetupWizardPage() {
  const [username, setUsername] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { refresh } = useAuth()

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)

    if (password !== passwordConfirm) {
      setError('Die Passwörter stimmen nicht überein.')
      return
    }
    if (password.length < 10) {
      setError('Das Passwort muss mindestens 10 Zeichen lang sein.')
      return
    }

    setLoading(true)
    try {
      await authApi.setup({ username, displayName, email: email || undefined, password })
      await refresh()
      navigate('/', { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Ersteinrichtung fehlgeschlagen.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <div className={styles.step}>Ersteinrichtung · Schritt 1 von 1</div>
      <h1 className={styles.title}>Administrator-Konto anlegen</h1>
      <p className={styles.subtitle}>
        Es wurde noch kein Benutzer gefunden. Lege den ersten Account an — er erhält automatisch
        volle Administratorrechte.
      </p>
      <form className={styles.form} onSubmit={onSubmit}>
        {error ? <div className={styles.error}>{error}</div> : null}
        <Field label="Benutzername" htmlFor="su-username" hint="Nur Buchstaben, Zahlen, . _ -">
          <Input id="su-username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus />
        </Field>
        <Field label="Anzeigename" htmlFor="su-displayname">
          <Input id="su-displayname" value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />
        </Field>
        <Field label="E-Mail (optional)" htmlFor="su-email">
          <Input id="su-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Passwort" htmlFor="su-password" hint="Mindestens 10 Zeichen">
          <Input
            id="su-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={10}
          />
        </Field>
        <Field label="Passwort bestätigen" htmlFor="su-password-confirm">
          <Input
            id="su-password-confirm"
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            required
          />
        </Field>
        <Button type="submit" variant="primary" fullWidth loading={loading} className={styles.submitGlow}>
          Administrator anlegen & starten
        </Button>
      </form>
    </AuthLayout>
  )
}
